import { render, staticRenderFns } from "./SalesRankingPrint.vue?vue&type=template&id=24071d47&scoped=true"
import script from "./SalesRankingPrint.vue?vue&type=script&lang=js"
export * from "./SalesRankingPrint.vue?vue&type=script&lang=js"
import style0 from "./SalesRankingPrint.vue?vue&type=style&index=0&id=24071d47&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24071d47",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24071d47')) {
      api.createRecord('24071d47', component.options)
    } else {
      api.reload('24071d47', component.options)
    }
    module.hot.accept("./SalesRankingPrint.vue?vue&type=template&id=24071d47&scoped=true", function () {
      api.rerender('24071d47', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plugin/sales-ranking/SalesRankingPrint.vue"
export default component.exports